export default "__VITE_ASSET__DAqZ_K0L__"